import { DateTime } from '@ksyos/date-time';

export function addAddendumTimeCheck(diagnosticReportDateSent?: DateTime) {
    if (!diagnosticReportDateSent) {
        return false;
    }

    return DateTime.now().subtract(1, 'day').isBefore(diagnosticReportDateSent);
}
